/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Form_NeutralInputs */

const en_coach_form_neutral = /** @type {(inputs: Coach_Form_NeutralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neutral Zone. Maintain aerobic focus.`)
};

const de_coach_form_neutral = /** @type {(inputs: Coach_Form_NeutralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neutrale Zone. Bleib am aeroben Fokus dran.`)
};

/**
* | output |
* | --- |
* | "Neutral Zone. Maintain aerobic focus." |
*
* @param {Coach_Form_NeutralInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const coach_form_neutral = /** @type {((inputs?: Coach_Form_NeutralInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Form_NeutralInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_coach_form_neutral(inputs)
	return de_coach_form_neutral(inputs)
});